<template>
    <div>
        <div class="hero int-page">
            <TDSHead/>
        </div>
        <div class="container-fluid bg-light main-content">
            <div class="container py-4 py-lg-8">
                <div class="row mb-10">
                    <div class="col-12">
                        <div class="row mb-5">
                            <div class="col-md-5 text-center">
                                <div class="">
                                    <img :src="`${publicPath}contatti/bg/venezia.jpg`" class="card-img-top mb-3 rounded" :alt="$t('contatti.venezia.title')">
                                    <img src="" class="card-img-top mb-3">
                                    <div class="">
                                        <h3 class="font-weight-bold text-orange">{{$t('contatti.venezia.title')}}</h3>
                                        <p>{{$t('contatti.venezia.text')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 offset-md-1 d-flex align-items-center justify-content-center">
                                <div>
                                    <div class="row text-center d-lg-flex align-items-start mb-4">
                                        <div class="col-12 col-lg-4 mb-4">
                                            <div class="h6 m-0 mb-2 font-family-sans-serif">
                                                <div class="font-weight-bold m-0 text-primary text-orange">{{$t('contatti.data.area_1.area')}}</div>
                                                <div class="font-weight-bold text-dark">{{$t('contatti.data.area_1.person')}}</div>
                                            </div>
                                            <a class="d-block text-muted m-0" :href="'mailto:'+ $t('contatti.data.area_1.email')">{{$t('contatti.data.area_1.email')}}</a>
                                            <a class="d-block text-muted m-0" :href="'tel:'+ $t('contatti.data.area_1.tel_1')">{{$t('contatti.data.area_1.tel_1')}}</a>                                            
                                        </div>
                                        <div class="col-12 col-lg-4 mb-4">
                                            <div class="h6 m-0 mb-2 font-family-sans-serif">
                                                <div class="font-weight-bold m-0 text-primary text-orange">{{$t('contatti.data.area_2.area')}}</div>
                                                <div class="font-weight-bold text-dark">{{$t('contatti.data.area_2.person')}}</div>
                                            </div>
                                            <a class="d-block text-muted m-0" :href="'mailto:'+ $t('contatti.data.area_2.email')">{{$t('contatti.data.area_2.email')}}</a>
                                            <a class="d-block text-muted m-0" :href="'tel:'+ $t('contatti.data.area_2.tel_1')">
                                                {{$t('contatti.data.area_2.tel_1')}}<sup class="pl-1 small">{{$t('fax_label')}}</sup>
                                            </a>
                                        </div>
                                        <div class="col-12 col-lg-4 mb-4">
                                            <div class="h6 m-0 mb-2 font-family-sans-serif">
                                                <div class="font-weight-bold m-0 text-primary text-orange">{{$t('contatti.data.area_3.area')}}</div>
                                                <div class="font-weight-bold text-dark">{{$t('contatti.data.area_3.person')}}</div>
                                            </div>
                                            <a class="d-block text-muted m-0" :href="'mailto:'+ $t('contatti.data.area_3.email')">{{$t('contatti.data.area_3.email')}}</a>

                                        </div>
                                        <div class="col-12 col-lg-4 mb-4">
                                            <div class="h6 m-0 mb-2 font-family-sans-serif">
                                                <div class="font-weight-bold m-0 text-primary text-orange">{{$t('contatti.data.area_4.area')}}</div>
                                                <div class="font-weight-bold text-dark">{{$t('contatti.data.area_4.person')}}</div>
                                            </div>
                                            <a class="d-block text-muted m-0" :href="'mailto:'+ $t('contatti.data.area_4.email')">{{$t('contatti.data.area_4.email')}}</a>
                                        </div>
                                        <div class="col-12 col-lg-4 mb-4">
                                            <div class="h6 m-0 mb-2 font-family-sans-serif">
                                                <div class="font-weight-bold m-0 text-primary text-orange">{{$t('contatti.data.area_5.area')}}</div>
                                                <div class="font-weight-bold text-dark">{{$t('contatti.data.area_5.person')}}</div>
                                            </div>
                                            <a class="d-block text-muted m-0" :href="'mailto:'+ $t('contatti.data.area_5.email')">{{$t('contatti.data.area_5.email')}}</a>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="w-100">
                                        <a :href="brochure" @click="track('file_download','presentation','pdf')" target="_blank">
                                            <div class="text-center d-flex align-items-center justify-content-between bg-white py-4 px-5 rounded">
                                                <div class="text-left">
                                                    <h2 class="font-weight-bold text-orange h5 m-0 font-family-sans-serif">{{$t('contatti.keynote.eyebrow')}}</h2>
                                                    <h1 class="font-weight-bold text-primary h5 m-0 font-family-sans-serif">{{$t('contatti.keynote.title')}}</h1>
                                                </div>
                                                <div class="text-center">
                                                    <img src="../assets/svg/chart-doc-icon.svg" height="50" :alt="$t('contatti.keynote.title')">
                                                    <span class="d-block small text-dark">{{$t('contatti.keynote.cta')}}</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-deck card-services">
                            <Location
                                    :title="$t('contatti.roma.title')"
                                    image_bg="contatti/bg/roma.jpg"
                                    :text="$t('contatti.roma.text')">
                            </Location>
                            <Location
                                    :title="$t('contatti.firenze.title')"
                                    image_bg="contatti/bg/firenze.jpg"
                                    :text="$t('contatti.firenze.text')">
                            </Location>
                            <Location
                                    :title="$t('contatti.catania.title')"
                                    image_bg="contatti/bg/catania.jpg"
                                    :text="$t('contatti.catania.text')">
                            </Location>
                        </div>
                        <div class="card-deck card-services">
                            <Location
                                    :title="$t('contatti.udine.title')"
                                    image_bg="contatti/bg/udine.jpg"
                                    :text="$t('contatti.udine.text')">
                            </Location>
                            <Location
                                    :title="$t('contatti.cagliari.title')"
                                    image_bg="contatti/bg/cagliari.jpg"
                                    :text="$t('contatti.cagliari.text')">
                            </Location>
                            <Location
                                    :title="$t('contatti.salerno.title')"
                                    image_bg="contatti/bg/salerno.jpg"
                                    :text="$t('contatti.salerno.text')">
                            </Location>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row mt-5">
                    <div class="col-12 text-center">
                        <h3 class="font-weight-bold text-primary h3 m-0 mb-5">{{$t('contatti.jobs.title')}}</h3>
                    </div>
                    <div class="col-lg-12 text-center mt-3">
                        <router-link tag="a" :to="$i18nRoute({ name: 'lavora-con-noi'})" class="btn btn-orange">{{$t('contatti.jobs.cta')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <TDSFoot/>
    </div>
</template>

<script>
    import BaseVue from "../views/BaseVue"
    import Location from '../components/Location'

    export default {
        extends: BaseVue,
        components: {
            Location
        },
        data () {
            return {
                publicPath: process.env.BASE_URL
            }
        },
        name: 'contatti',
        metaInfo() {
            return {
                title: 'Contatti - TDS.sport',
            }
        },
        computed: {
            brochure: function() {
                if (this.$store.state.lang === 'it') {
                    return `${this.publicPath}pdf/brochure_TDS_ita.pdf`
                } else {
                    return `${this.publicPath}pdf/brochure_TDS_eng.pdf`
                }
            }
        }
    }
</script>
